/**
 * Versione applicativa inviata con le segnalazioni di supporto.
 * Tenere allineata a "version" in package.json.
 */
export const APP_VERSION = '19.0.0'
